import { useEffect } from 'react';
import { useLocation, matchPath } from 'react-router-dom';
import { useSelector } from 'react-redux';

const getUrlTitle = (pathname) => {
  const segment = pathname.split('/').filter(Boolean)[0] || 'Dashboard';
  return segment
    .split('-')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

const useDynamicPageTitle = () => {
  const { pathname } = useLocation();

  const phoneTrackingNumbers = useSelector(
    (state) => state.phoneTrackingReducers?.phoneTrackingNumbers
  );

  useEffect(() => {
    const phoneTrackingMatch = matchPath('/phone-tracking/:id/:type', pathname);

    if (phoneTrackingMatch) {
      const { id, type } = phoneTrackingMatch.params;
      const phone = phoneTrackingNumbers?.find((p) => String(p.id) === String(id));
      const name = phone?.name;

      if (type === 'call') {
        document.title = name ? `Call History - ${name}` : 'Call History';
      } else if (type === 'sms') {
        document.title = name ? `SMS History - ${name}` : 'SMS History';
      }
      return;
    }

    document.title = getUrlTitle(pathname);
  }, [pathname, phoneTrackingNumbers]);
};

export { useDynamicPageTitle };
